import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import Buttons from '../Buttons';
import ZoomSlider from '../ZoomSlider';
import Alerts from '../Alerts';

const FormUpload = styled.form`
  background-color: ${props => props.theme.colors.light};
  padding: ${rem('25px')};

  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('49px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('430px')};
  `};
`;

const NameUser = styled.h2`
  margin-bottom: ${rem('30px')};
  font-family: ${props => props.theme.fonts.medium};
  text-align: center;
  padding-top: ${rem('25px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('26px')};
    line-height: ${rem('38px')};
    margin-bottom: ${rem('12px')};
    padding-top: 0;
  `};
`;

const WrapperAvatar = styled.div`
  max-width: ${rem('192px')};
  margin: 0 auto ${rem('38px')} auto;

  ${mediaqueries.greaterThan('mobile')`
    margin: 0 auto 2rem auto;
    max-width: ${rem('300px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    max-width: 70%;  
  `};
`;

const ZoomPhoto = styled(ZoomSlider)`
  margin: 0 auto 1rem auto;

  ${mediaqueries.greaterThan('mobile')`
    max-width: 100%;
  `};
`;

const WrapperButtons = styled.div`
  width: ${rem('300px')};
  display: flex;
  justify-content: space-between;
  margin: 0 auto 1rem auto;
  position: relative;
  ${mediaqueries.greaterThan('mobile')`
    margin-bottom: 2rem;
  `};
  button {
    margin: 0;
  }
`;

const FormButtons = styled(Buttons)`
  ${props =>
    props.disabled === false &&
    `
      font-size: 80%;
      margin: 0 0.5rem;
      border: ${rem('2px')} solid ${props => props.theme.colors.primary};
      padding: ${rem('7px')} ${rem('20px')};
      &:hover {
        background-color: ${props => props.theme.colors.dark};
        color: ${props => props.theme.colors.light};
        border: ${rem('2px')} solid ${props => props.theme.colors.dark};
      }
    `}

  ${props =>
    props.disabled === true &&
    `
      background-color: ${props => props.theme.colors.gray};
      color: ${props => props.theme.colors.light};
      border: 0;
      &:hover {
        background-color: ${props => props.theme.colors.gray};
        border: 0;
      }
    `}
`;

const FormButtonsInvested = FormButtons.extend`
  ${props =>
    props.disabled === false &&
    `
    background-color: transparent;
  color: ${props => props.theme.colors.primary};
  border: ${rem('2px')} solid;
  box-sizing: border-box;

  &:hover {
    background-color: ${props => props.theme.colors.dark};
    border: ${rem('2px')} solid transparent;
  }
    `}

  ${props =>
    props.disabled === true &&
    `
      background-color: ${props => props.theme.colors.gray};
      color: ${props => props.theme.colors.light};
      border: 0;
      &:hover {
        background-color: ${props => props.theme.colors.gray};
        border: 0;
      }
    `}
`;

const Paragraph = styled.p`
  color: ${props => props.theme.colors.gray};
  font-size: ${rem('11px')};
  line-height: 1.4;

  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.small};  
  `};
`;

const StyledAlerts = styled(Alerts)`
  width: ${rem('300px')};
  margin: ${rem('-18px')} auto;
  position: absolute;
  bottom: ${rem('-74px')};
  left: ${rem('1px')};
`;

export {
  FormUpload,
  NameUser,
  WrapperAvatar,
  ZoomPhoto,
  WrapperButtons,
  FormButtons,
  FormButtonsInvested,
  Paragraph,
  StyledAlerts
};
